import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';


const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }`

class NotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            isSubmitting: false,
        }
    }

    handleFormSubmit = async () => {
        this.setState({
            isSubmitting: true
        })
        let params = {
            notification_type: "fee",
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.props.stateData.branch,
            term_no: parseInt(this.props.stateData.selectedTerm),
            template_name: "Fee Status",
        }


        this.setState({
            loadingSpinner: 1,
        });

        this.sendEduNotification(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 })
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        })
    }

    sendEduNotification = async params => {
        await this.props.sendEduNotification({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.sendEduNotification) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    sortFunc(a, b, order, dataField, rowA, rowB) {
        if (order === 'asc') return parseInt(a) - parseInt(b);
        else return parseInt(b) - parseInt(a);
    }

    sortFuncdate(a, b, order) {

        const dateStr = a;
        const [day, month, year] = dateStr.split('/');
        const timestamp = new Date(year, month - 1, day).getTime() / 1000;

        const dateStrtwo = b
        const [day1, month1, year1] = dateStrtwo.split('/');
        const timestamp2 = new Date(year1, month1 - 1, day1).getTime() / 1000;

        if (order === 'asc') return parseInt(timestamp) - parseInt(timestamp2);
        else return parseInt(timestamp2) - parseInt(timestamp);

    }

    Columns(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student name",
            },
            {
                dataField: "parent_mobile",
                text: "Parent mobile",
            },
            {
                dataField: "term_amount",
                text: "Pending Amount",
                sortFunc: this.sortFunc.bind(this),
                sort: true
            },
            {
                dataField: "term_date",
                text: "Last Date",
                sortFunc: this.sortFuncdate.bind(this),
                sort: true

            },
        ];
        return Columns;
    }

    render() {

        const styles = {
            cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
            backgroundColor: this.state.isSubmitting ? "#213046" : "#213046",
            color: this.state.isSubmitting ? "#fff" : "#fff",
            padding: this.state.isSubmitting ? "6px" : "6px",
            width: this.state.isSubmitting ? "181px" : "181px"
        };


        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="example-modal-sizes-title-lg"
                className="notify_modal"
            >
                <Modal.Header closeButton className="notify_header d-flex justify-content-center">
                    <h6 className="text-center mt-2">Term {this.props.stateData.selectedTerm} Pending Students</h6>
                </Modal.Header>


                {
                    this.props.stateData.loaderforModal == 1 ?
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col >
                                </Row>
                            </Container >
                        )
                        :
                        (
                            <>
                                <Modal.Body className="p-1">
                                    <CardLessDataTableWithOutSearch
                                        parentData={this.props.stateData.getTermWisePendingStudents}
                                        particlecolumns={this.Columns()}
                                    />
                                </Modal.Body>

                                <Modal.Footer variant="white" className="notify_footer">
                                    <Row>
                                        <Col sm={12}>
                                            {this.state.currentStep == 5 ? (
                                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                                    Notification sent successfully
                                                </Form.Text>
                                            ) : (
                                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                                    {this.state.submitError}
                                                </Form.Text>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                                            <Button className="text-uppercase" style={styles} onClick={(e) => this.handleFormSubmit()}>
                                                {
                                                    this.state.loadingSpinner == 1 ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : ""
                                                }
                                                send Notification</Button>
                                        </Col>

                                    </Row>
                                </Modal.Footer>
                            </>
                        )
                }
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(SEND_NOTIFICATION, {
        name: "sendEduNotification"
    })
)(NotificationModal)));